import { Maybe, fromNullable, just, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import MultipleSelectionsInput from '../../../../../../../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';
import WithField from '../../../../../../../../Resource/FormTemplates/Inputs/WithField';
import {
  FormTemplate,
  SelectionOption,
  findField,
} from '../../../../../../../../Resource/FormTemplates/Types';

interface Props {
  template: FormTemplate;
  dataIntercomTarget?: string;
}

type ClientGroupsSelection = 'client-groups';

const typifyCollaboratorSelection = (
  collaboratorSelection: SelectionOption,
): Maybe<ClientGroupsSelection> => {
  switch (collaboratorSelection.value) {
    case 'client-groups':
      return just('client-groups');
    case 'organization':
    case 'private':
    default:
      return nothing();
  }
};

const clientGroupsSelected = (template: FormTemplate): Maybe<ClientGroupsSelection> =>
  findField('permission_type', 'single-selection', template.fields)
    .andThen(({ value }) => fromNullable(value))
    .andThen(typifyCollaboratorSelection);

function ClientGroupsSelector({ template, dataIntercomTarget }: Props) {
  return clientGroupsSelected(template)
    .map(() => (
      <WithField kind="multiple-selection" name="client_groups" fields={template.fields}>
        {(field) => (
          <MultipleSelectionsInput field={field} dataIntercomTarget={dataIntercomTarget} />
        )}
      </WithField>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ClientGroupsSelector);
